import { WriteRight } from "@pilot-web/settings-permissions";
export const Rights = [
    WriteRight
]
